<template>
  <div class="verification-details-photos">
    <template v-if="verificationDetails.isNotEmptyDocumentsArray">
      <div class="verification-details-photos__section">
        <h3 class="verification-details-photos__subtitle">
          {{ 'verification-details.key-documents' | globalize }}
        </h3>

        <a-list
          :grid="{ gutter: 12, xs: 1, sm: 2, md: 3, lg: 3, xl: 4, xxl: 4 }"
          :data-source="verificationDetails.documentsArray">
          <a-list-item
            slot="renderItem"
            slot-scope="item"
          >
            <verification-document
              :document="item"
              :on-select-image-url="selectPhotoUrl"
            />
          </a-list-item>
        </a-list>
      </div>
    </template>

    <template v-if="verificationDetails.isNotEmptySelfie">
      <div class="verification-details-photos__section">
        <h3 class="verification-details-photos__subtitle">
          {{ 'verification-details.key-selfie' | globalize }}
        </h3>

        <div class="verification-details-photos__img-wrp">
          <img
            class="app__img-preview"
            :src="verificationDetails.documents.selfie"
            @click="selectPhotoUrl(verificationDetails.documents.selfie)"
          >
        </div>
      </div>
    </template>

    <template v-if="verificationDetails.isNotEmptyDocImages">
      <div class="verification-details-photos__section app-key-value__row">
        <button
          v-ripple
          class="verification-details-photos__dropdown-btn"
          type="button"
          @click="isImagesDocsShown = !isImagesDocsShown"
        >
          <i
            class="mdi verification-details-photos__dropdown-btn-icon"
            :class="{
              'mdi-chevron-right': !isImagesDocsShown,
              'mdi-chevron-down': isImagesDocsShown
            }"
          />
          <h3 class="verification-details-photos__subtitle">
            {{ 'verification-details.key-document-images' | globalize }}
          </h3>
        </button>
        <template v-if="isImagesDocsShown">
          <div class="verification-details-photos__img-wrp">
            <img
              class="app__img-preview"
              v-for="image in verificationDetails.documents.documentImages"
              :key="image"
              :src="image"
              @click="selectPhotoUrl(image)"
            >
          </div>
        </template>
      </div>
    </template>

    <photo-viewer
      v-if="selectedPhotoUrl"
      :img-url="selectedPhotoUrl"
      :is-shown.sync="isImageViewerShown"
    />
  </div>
</template>

<script>
import AList from 'ant-design-vue/lib/list'
import VerificationDocument from '@/vue/common/verification-document'
import { VerificationRecord } from '@/js/records/entities/verification.record'
import PhotoViewer from '@/vue/common/PhotoViewer'

export default {
  name: 'verification-details-photos',
  components: {
    PhotoViewer,
    VerificationDocument,
    AList,
    'a-list-item': AList.Item,
  },
  props: {
    verificationDetails: {
      type: VerificationRecord,
      required: true,
    },
  },
  data: () => ({
    selectedPhotoUrl: '',
    isImageViewerShown: false,
    isImagesDocsShown: false,
  }),
  methods: {
    selectPhotoUrl (url) {
      this.selectedPhotoUrl = url
      this.isImageViewerShown = true
    },
  },
}
</script>

<style lang="scss">
@import '~ant-design-vue/lib/list/style/index.css';

.verification-details-photos__subtitle {
  margin-bottom: 2rem;
}

.verification-details-photos__section {
  margin-top: 3rem;
}

.verification-details-photos__img-wrp {
  display: flex;
  gap: 1rem;
  max-width: 15rem;
  width: 100%;
}

.verification-details-photos__dropdown-btn {
  display: flex;
  justify-content: flex-start;
  margin-top: 1rem;
}

.verification-details-photos__dropdown-btn-icon {
  display: block;
  font-size: 2rem;
  height: 2rem;
  width: 2rem;
  line-height: 1.8rem;
  transition: all 0.3s;
}
</style>
